import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Country } from '@angular-material-extensions/select-country';
import { countryPH, countryUS } from '../../../core/helpers/countries';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'app-country-code-selector',
  templateUrl: './country-code-selector.component.html',
  styleUrls: ['./country-code-selector.component.scss'],
})
export class CountryCodeSelectorComponent {
  @Output() countrySelected = new EventEmitter<Country>();
  @Input() appearance: MatFormFieldAppearance;
  public countries: Country[] = [countryUS, countryPH];
  public defaultCountry = countryUS;
  public selectedCountry = countryUS;

  public selected(country: Country): void {
    this.countrySelected.emit(country);
  }
}
